import React from 'react';
import NodeHandles from './NodeHandles';
import {mChoiceAnswerCorrect} from '../../../assets/images';

const ChallengeBranchAICorrectNode = React.memo(() => {
  return (
    <NodeHandles>
      <div>
        <img src={mChoiceAnswerCorrect} />
      </div>
    </NodeHandles>
  );
});

export default ChallengeBranchAICorrectNode;
